export const CategoryConstant = {
    Global:"Global",
    DocumentCentre:"Document Centre",
    EngagementDetail:"Engagement Detail",
    AboutRdc:"About Rdc",
    ContactUs:"Contact Us",
    AddEngagement:"Add Engagement",
    EditEngagement:"Edit Engagement",
    ManageFolder:"Manage Folder",
    ManageDocument:"Manage Document",
    UploadDocument:"Upload Document",
    EditDocument:"Edit Document",
    UserManagement:"User Management",
    LanguageConfiguration:"Language Configuration",
    FolderTemplate:"Folder Template",
    EmailTemplate:"Email Template",
    ManageLogoandIcon:"Manage Logo and Icon",
    LabelCardManagement:"Label Card Management",
    Links:"Links",
    DocumentTypes:"DocumentTypes",
    IconCategory:"IconCategory",
    ImageType:"ImageType",
    Language:"Language",
    Status:"Status",
    UserRole:"UserRole",
    RoleMasterList:"RoleMasterList",
    JurisdictionList:"JurisdictionList",
    Title:"Title",
    SortTypes:"SortTypes",
    DocumentsApproval:"Document Approval",
    TopicCards:"Topic Card",
    EmailTemplateTypes:"Email Template Types",
    Calendar:"Calendar",
    PublicUserList:"Public User List",
    IconCategoryList:"Icon Category List"

};  
